import * as Constants from "./Constants";

var month = [];
month[0] = "Jan";
month[1] = "Feb";
month[2] = "Mar";
month[3] = "Apr";
month[4] = "May";
month[5] = "Jun";
month[6] = "Jul";
month[7] = "Aug";
month[8] = "Sep";
month[9] = "Oct";
month[10] = "Nov";
month[11] = "Dec";

const _smartEncodingCodeMap = Constants.smartEncodingMapping.reduce(
  (acc, { Unicode, TransliteratedCharacter }) => {
    const code = parseInt(Unicode.replace(/^U\+/, ""), 16);
    acc[code] = TransliteratedCharacter;
    return acc;
  },
  {}
);

class HelperFunctions {

  static getSmartEncodingMap() {
    return _smartEncodingCodeMap;
  }

  static replaceSmartEncodingChars(text) {
    if (!text) return text;
    const map = HelperFunctions.getSmartEncodingMap();
    let result = "";
    for (let i = 0; i < text.length; ) {
      const cp = text.codePointAt(i);
      const ch = String.fromCodePoint(cp);
      result += map[cp] ?? ch;
      i += cp > 0xffff ? 2 : 1;
    }
    return result;
  }

  static formatOutput(val, type) {
    let value = "";
    switch (type) {
      case Constants.TOP_BOTTOM_ENUM.Currency:
        value = "$" + HelperFunctions.formatValue(val, 1);
        break;
      case Constants.TOP_BOTTOM_ENUM.CurrencyWithOutDecimal:
        value = "$" + HelperFunctions.formatValue(val, 0);
        break;
      case Constants.TOP_BOTTOM_ENUM.Percentage:
        value = HelperFunctions.formatValue(val, 2) + "%";
        break;
      case Constants.TOP_BOTTOM_ENUM.Numeric:
        value = HelperFunctions.formatValue(val, 1);
        break;
      default:
        value = val;
        break;
    }
    return value;
  }

  static formatValue(value, precision) {
    let formattedValue = value;
    let postFix = "";

    if (value >= 1000000000) {
      formattedValue = value / 1000000000;
      postFix = "b";
    } else if (value >= 1000000) {
      formattedValue = value / 1000000;
      postFix = "m";
    } else if (value >= 1000) {
      formattedValue = value / 1000;
      postFix = "k";
    } else {
      formattedValue = value / 1;
    }

    if (formattedValue.toFixed(precision) % 1 === 0) {
      return formattedValue.toFixed(0) + postFix;
    } else {
      return formattedValue.toFixed(precision) + postFix;
    }
  }

  static formateNumberbyCommas(params, prefix = true, precision = 2, isDecemail = false) {
    let prefixvalue = prefix ? "$" : "";
    if (params) {
      var isDecimalNum = (params - Math.floor(params)) !== 0;
      var num = params;

      if (isDecimalNum) {
        num = params.toFixed(precision);
      }

      if (isDecemail === false) {
        num = Math.round(num);
      }

      return (
        prefixvalue +
        num.toString()
          .replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,")
      );
    } else {
      return "N/A";
    }
  }

  static getMondayOfCurrentWeek(d) {
    var day = d.getDay();
    return new Date(
      d.getFullYear(),
      d.getMonth(),
      d.getDate() + (day === 0 ? -6 : 1) - day
    );
  }
  static getSundayOfCurrentWeek(d) {
    var day = d.getDay();
    return new Date(
      d.getFullYear(),
      d.getMonth(),
      d.getDate() + (day === 0 ? 0 : 7) - day
    );
  }
  static getfirstDayOfCurrentMonth() {
    var date = new Date();
    return new Date(date.getFullYear(), date.getMonth(), 1);
  }
  static getlastDayOfCurrentMonth() {
    var date = new Date();
    return new Date(date.getFullYear(), date.getMonth() + 1, 0);
  }

  static formatBytes(bytes, decimals = 2) {
    if (bytes === 0) return "0 Bytes";
    const k = 1024;
    const dm = decimals < 0 ? 0 : decimals;
    const sizes = ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + " " + sizes[i];
  }

  static RGBToHex(rgb) {
    // Choose correct separator
    let sep = rgb.indexOf(",") > -1 ? "," : " ";
    // Turn "rgb(r,g,b)" into [r,g,b]
    rgb = rgb.substr(4).split(")")[0].split(sep);

    let r = (+rgb[0]).toString(16),
      g = (+rgb[1]).toString(16),
      b = (+rgb[2]).toString(16);

    if (r.length === 1) r = "0" + r;
    if (g.length === 1) g = "0" + g;
    if (b.length === 1) b = "0" + b;

    return "#" + r + g + b;
  }

  static shadeColor(color, percent) {
    var R = parseInt(color.substring(1, 3), 16);
    var G = parseInt(color.substring(3, 5), 16);
    var B = parseInt(color.substring(5, 7), 16);

    R = parseInt((R * (100 + percent)) / 100);
    G = parseInt((G * (100 + percent)) / 100);
    B = parseInt((B * (100 + percent)) / 100);

    R = R < 255 ? R : 255;
    G = G < 255 ? G : 255;
    B = B < 255 ? B : 255;

    var RR = R.toString(16).length === 1 ? "0" + R.toString(16) : R.toString(16);
    var GG = G.toString(16).length === 1 ? "0" + G.toString(16) : G.toString(16);
    var BB = B.toString(16).length === 1 ? "0" + B.toString(16) : B.toString(16);

    return "#" + RR + GG + BB;
  }

  static getLocalTimestringInAmpmFromUTCStartTimeVnext(timeStamp) {
    if (timeStamp) {
      var date = new Date('1970-01-01T' + timeStamp + 'Z');
      var localDate = new Date(date.getTime() + (date.getTimezoneOffset() * 60000))
      var minute = localDate.getMinutes();
      var hour = localDate.getHours();
      var ampm = hour >= 12 ? "pm" : "am";
      hour = hour % 12;
      hour = hour ? hour : 12; // the hour '0' should be '12'
      minute = minute < 10 ? "0" + minute : minute;
      var strTime = hour + ":" + minute + " " + ampm;
      return strTime;
    }
  }

  static getLocalTimestringInAmpmFromUTCDateVnext(utcDate) {
    var localDate = new Date(utcDate);
    var minute = localDate.getMinutes();
    var hour = localDate.getHours();
    var ampm = hour >= 12 ? "pm" : "am";
    hour = hour % 12;
    hour = hour ? hour : 12; // the hour '0' should be '12'
    minute = minute < 10 ? "0" + minute : minute;
    var strTime = hour + ":" + minute + " " + ampm;
    return strTime;
  }

  static getLocalDatePartstringFromUTCDateVnext(utcDate) {
    var localDate = new Date(utcDate);
    return localDate.toLocaleDateString();
  }

  static getLocalDateTimePartstringFromUTCDateVnext(utcDate) {
    var localDate = new Date(utcDate);

    return localDate.toLocaleString();
  }

  static getLocalMonthYearFromUTCDateVnext(utcDate) {
    var localDate = new Date(utcDate);

    return month[localDate.getMonth()] + " " + localDate.getFullYear();
  }

  static getLocalMonthDateYearTimeFromDateVnext(date) {
    var formatedDate = "";
    if (date) {
      var dt = new Date(date);
      var hours = dt.getHours();
      var minutes = (dt.getMinutes() < 10 ? "0" : "") + dt.getMinutes();
      var ampm = hours >= 12 ? "PM" : "AM";
      hours = hours % 12;
      hours = hours ? hours : 12; // the hour '0' should be '12'
      formatedDate =
        month[dt.getMonth()] +
        ". " +
        dt.getDate() +
        ", " +
        dt.getFullYear() +
        " - " +
        (hours + ":" + minutes + " " + ampm);
    }
    return formatedDate;
  }

  //for design library need to delete once design library is upgraded
  static getLocalTimestringInAmpmFromUTCDate(utcDate) {
    var strTime = "";
    if (utcDate) {
      var localDate = new Date(parseInt(utcDate.replace(/[^0-9 +]/g, "")));
      var minute = localDate.getMinutes();
      var hour = localDate.getHours();
      var ampm = hour >= 12 ? "pm" : "am";
      hour = hour % 12;
      hour = hour ? hour : 12; // the hour '0' should be '12'
      minute = minute < 10 ? "0" + minute : minute;
      strTime = hour + ":" + minute + " " + ampm;
    }
    return strTime;
  }

  static getLocalDatePartstringFromUTCDate(utcDate) {
    if (utcDate && utcDate.length > 0) {
      var localDate = new Date(parseInt(utcDate.replace(/[^0-9 +]/g, "")));
      return localDate.toLocaleDateString();
    }
  }

  static getLocalDateTimePartstringFromUTCDate(utcDate) {
    if (utcDate && utcDate.length > 0) {
      var localDate = new Date(parseInt(utcDate.replace(/[^0-9 +]/g, "")));
      return localDate.toLocaleString();
    }
  }

  static getLocalMonthYearFromUTCDate(utcDate) {
    if (utcDate && utcDate.length > 0) {
      var localDate = new Date(parseInt(utcDate.replace(/[^0-9 +]/g, "")));

      return month[localDate.getMonth()] + " " + localDate.getFullYear();
    }
  }

  static convertToDateObjectVNext(dateString) {
    let newDate = new Date();
    if (dateString && dateString.length > 0) {
      let year = dateString.substring(0, 4);
      let month = dateString.substring(5, 7);
      let day = dateString.substring(8, 10);
      // construct new date object for sorting
      newDate = new Date(year, parseInt(month) - 1, day);  /* months 0..11 */
    }
    return newDate;
  }

  static responseHandler(data) {
    var response = [];
    if (data.OperationSuccessful) {
      if (data.Content) {
        response = data.Content;
      } else {
        response = data.content;
      }
    }
    return response;
  }

  static responseHandlerVNext(data) {
    var response = [];
    if (data.operationSuccessful && data.content) {
      response = data.content;
    }
    return response;
  }

    static validateEmail(email) {
        const re = /^(?=.{1,254}$)(?=.{1,64}@)[A-Za-z0-9]+(?:[._%+-][A-Za-z0-9]+)*@(?:[A-Za-z0-9](?:[A-Za-z0-9-]{0,61}[A-Za-z0-9])?\.)+[A-Za-z]{2,}$/g;

        if (re.test(email)) {
            return true;
        }
        return false;
    }

  static formatPhoneNumbers = (numbers) => {
    return numbers?.map((number) => ({
      value: number.id,
      label: number.phoneNumber,
      isDefault: number.isDefault,
    }));
  };

  static validatePhoneNumberForUI(phoneNumber) {
    let isValid = false;

    const regex = /^\+?(?<CountryCode>\d{1,3})?\(?(?<AreaCode>\d{3})\)?[\s.-]?(?<Prefix>\d{3})[\s.-]?(?<LineNumber>\d{4,6})$/;
    const match = regex.exec(phoneNumber);
    if (match) {
      isValid = true;
    }
    return isValid;
  }

  static refinePhoneNumber(phoneNumber) {
    const regex = /^\+?(?<CountryCode>\d{1,3})?\(?(?<AreaCode>\d{3})\)?[\s.-]?(?<Prefix>\d{3})[\s.-]?(?<LineNumber>\d{4,6})$/;
    const match = regex.exec(phoneNumber);
    if (match) {
      const countryCode = match.groups.CountryCode || '1';
      return `${countryCode}${match.groups.AreaCode}${match.groups.Prefix}${match.groups.LineNumber}`;
    }
    return "";
  }

  static validatePhoneNumber(phoneNumber) {
    // Regular expression for exactly 10 digits
    const re = /^[0-9]{10}$/;

    return re.test(phoneNumber);
  }

  static isTollFree(phoneNumber) {
    if (phoneNumber) {
      // Remove any non-digit characters from the phone number
      const sanitizedPhoneNumber = phoneNumber.replace(/\D/g, '');
      // Check if the sanitized phone number has 10 digits and starts with '8'
      phoneNumber = sanitizedPhoneNumber.length === 10 && sanitizedPhoneNumber.charAt(0) === '8';
    }
    return phoneNumber;
  }

  static formatPhoneNumber(phoneNumber) {
    return phoneNumber?.replace(/(\d{3})(\d{3})(\d{4})/, "($1)$2-$3");
  }

  static validateNumber(email) {
    const re = /[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,3}/g;

    if (re.test(email)) {
      return true;
    }
    return false;
  }

  static validateURL(url) {
    const re =
      /^(https?:\/\/)[\w.-]+(?:\.[\w.-]+)+[\w\-\._~:/?#[\]@!\$&'\(\)\*\+,;=%]+$/g;
    if (re.test(url)) {
      return true;
    }
    return false;
  }

  static customerLookupClearStorage() {
    localStorage.removeItem('pageSearch');
  }

  static IsValidJsonString(str) {
    try {
      JSON.parse(str);
    } catch (e) {
      return false;
    }
    return true;
  }

  static checkUserPermions(arr, value) {
    if (arr) {
      const permissions = arr.find((item) => item.ClaimType === "Permissions");
      if (permissions) {
        const found = permissions.ClaimValue.find((item) => item === value);
        if (found) return true;
        else return false;
      } else {
        return false;
      }
    }
  }

  static getCookie(cname) {
    let name = cname + "=";
    let decodedCookie = decodeURIComponent(document.cookie);
    let ca = decodedCookie.split(";");
    for (var i = 0; i < ca.length; i++) {
      let c = ca[i];
      while (c.charAt(0) === " ") {
        c = c.substring(1);
      }
      if (c.indexOf(name) === 0) {
        return c.substring(name.length, c.length);
      }
    }

    return "";
  }

  static setCookie(cname, cvalue, exdays) {
    var d = new Date();
    d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
    var expires = "expires=" + d.toUTCString();
    document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
  }

  static expireCookie(cname, cvalue, exdays) {
    var d = new Date();
    d.setTime(d.getTime() - exdays * 24 * 60 * 60 * 1000);
    var expires = "expires=" + d.toUTCString();
    document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
  }

  // static extractUserClaims(key) {
  //   return localStorage
  //     .getItem("ClientUserClaims-" + localStorage.getItem("selectedClientId"))
  //     ?.split(",")
  //     ?.filter((a) => a.includes(key))
  //     ?.map((obj) => obj.split(".")[1].toLowerCase());
  // }

  static validateClientUserClaim(claimKey, operationKey, claims) {
    const key = claimKey + "." + operationKey;
    return claims?.some((a) => a === key);
  }
  static validateClientUserClaims(claimKeys, operationKey, claims) {
    var isExist = false;
    claimKeys.forEach((claimKey) => {
      var key = claimKey + "." + operationKey;
      if (!isExist) {
        isExist = claims?.some((a) => a === key);
      }
    });
    return isExist;
  }

  static formateDateWithMonthName(params) {
    const options = { year: 'numeric', month: 'long', day: 'numeric' };
    const date = new Date(params);
    return date.toLocaleDateString('en-US', options);
  }
  static formatDateWithTime(params) {
    if (params != null && params !== "") {
      let newDate = new Date(params);
      var returnDate = (newDate.getMonth() + 1).toString() + "/" + newDate.getDate().toString() + "/" + newDate.getFullYear().toString() + " " + newDate.getHours().toString() + ":" + newDate.getMinutes().toString() + ":" + newDate.getSeconds().toString() + " " + (newDate.getHours() >= 12 ? 'PM' : 'AM');
      return returnDate;
    } else {
      return params;
    }
  }
  static formatUTCDate(params) {
    if (params != null && params !== "") {
      let newDate = new Date(params);
      var returnDate = (newDate.getMonth() + 1).toString() + "/" + newDate.getDate().toString() + "/" + newDate.getFullYear().toString();
      return returnDate;
    } else {
      return params;
    }
  }

  static isGuestRole(roles) {
    if (roles && roles[0]?.toLowerCase() === "guest") {
      return true;
    } else {
      return false;
    }
  }

  static isBillingRoleAssigned(roles) {
    if (roles) {
      let isBillingRole = false;
      roles.forEach((role) => {
        if (role?.toLowerCase() === "billing") {
          isBillingRole = true;
        }
      });
      return isBillingRole;
    }
    return false;
  }

  static isOnlyGuestOrBillingRole(roles) {
    if (roles) {
      let isGuestRole = false;
      let isBillingRole = false;
      if (roles.length === 2) {
        roles.forEach((role) => {
          if (role?.toLowerCase() === "guest") {
            isGuestRole = true;
          }
          if (role?.toLowerCase() === "billing") {
            isBillingRole = true;
          }
        });
        return isGuestRole && isBillingRole;
      } else if (roles.length === 1) {
        roles.forEach((role) => {
          if (role?.toLowerCase() === "guest") {
            isGuestRole = true;
          }
          if (role?.toLowerCase() === "billing") {
            isBillingRole = true;
          }
        });
        return isGuestRole || isBillingRole;
      }
    }
    return false;
  }

  static isContractExpired(endDate) {
    if (endDate < new Date()) {
      return true;
    }
    return false;
  }

  static getClientContractExpirationTime(contractEndDate) {
    // Get the current date and time
    var currentDate = new Date();
    // Calculate the remaining time in milliseconds
    var remainingTime = contractEndDate.getTime() - currentDate.getTime();
    // Check if the contract end date has passed
    if (remainingTime > 0) {
      // Convert milliseconds to days, hours, minutes, and seconds
      var days = Math.floor(remainingTime / (1000 * 60 * 60 * 24));
      var hours = Math.floor((remainingTime % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      var minutes = Math.floor((remainingTime % (1000 * 60 * 60)) / (1000 * 60));

      // Create the remaining time string
      var remainingTimeString = "";

      // Build the message based on remaining time components
      if (days > 0) {
        remainingTimeString += days + " day" + (days > 1 ? "s" : "") + " ";
      }
      if (hours > 0) {
        remainingTimeString += hours + " hour" + (hours > 1 ? "s" : "") + " ";
      }
      if (minutes > 0) {
        remainingTimeString += minutes + " minute" + (minutes > 1 ? "s" : "") + " ";
      }

      // Display the remaining time or a default message if no time is remaining
      var message = remainingTimeString.trim();
      // if (message === "") {
      //   message = "Contract is ending soon";
      // } else {
      //   message += " remaining";
      // }
      // Check if the remaining time is less than 11 days
      if (days < 11) {
        return message
      }
    }
    return "";
  }

  // static getClientContractExpirationTime(endDate, gracePeriodDaysToChurn){
  //   var currentDate = new Date();
  //   var gracePeriodEndsOn = new Date(endDate);
  //   gracePeriodEndsOn.setDate(gracePeriodEndsOn.getDate() + gracePeriodDaysToChurn);
  //   console.log(endDate, gracePeriodDaysToChurn, gracePeriodEndsOn);
  //   if(gracePeriodEndsOn < currentDate.getDate()){
  //     return;
  //   }
  //    //Get the Timestamp
  //    let date1_time_stamp = currentDate.getTime();
  //    let date2_time_stamp = endDate.getTime();

  //   //  if(date2_time_stamp - date1_time_stamp <= 0){
  //   //   date2_time_stamp = currentDate.getTime();
  //   //   date1_time_stamp = endDate.getTime();
  //   //  }

  //    let calc;

  //    //Check which timestamp is greater
  //    calc = new Date(date2_time_stamp - date1_time_stamp);
  //    //Retrieve the date, month and year
  //    const calcFormatTmp = calc.getDate() + '-' + (calc.getMonth() + 1) + '-' + calc.getFullYear();
  //    //Convert to an array and store
  //    const calcFormat = calcFormatTmp.split("-");
  //    //Subtract each member of our array from the default date
  //    const days_passed = Number(Math.abs(calcFormat[0]) - 1);
  //    const months_passed = Number(Math.abs(calcFormat[1]) - 1);
  //    const years_passed = Number(Math.abs(calcFormat[2]) - 1970);

  //    //Set up custom text
  //    const yrsTxt = ["year", "years"];
  //    const mnthsTxt = ["month", "months"];
  //    const daysTxt = ["day", "days"];

  //    //Convert to days and sum together
  //    const total_days = (years_passed * 365) + (months_passed * 30.417) + days_passed;
  //    //display result with custom text
  //    const result = ((years_passed == 1) ? years_passed + ' ' + yrsTxt[0] + ' ' : (years_passed > 1) ?
  //        years_passed + ' ' + yrsTxt[1] + ' ' : '') +
  //        ((months_passed == 1) ? months_passed + ' ' + mnthsTxt[0] + ' ' : (months_passed > 1) ?
  //            months_passed + ' ' + mnthsTxt[1] + ' ' : '') +
  //        ((days_passed == 1) ? days_passed + ' ' + daysTxt[0] : (days_passed > 1) ?
  //            days_passed + ' ' + daysTxt[1] : '');

  //            //return the result
  //    return result.trim()
  // }

  static isValidUrl(str) {
    const pattern = new RegExp(
      '^([a-zA-Z]+:\\/\\/)?' + // protocol
      '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|' + // domain name
      '((\\d{1,3}\\.){3}\\d{1,3}))' + // OR IP (v4) address
      '(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*' + // port and path
      '(\\?[;&a-z\\d%_.~+=-]*)?' + // query string
      '(\\#[-a-z\\d_]*)?$', // fragment locator
      'i'
    );
    return pattern.test(str);
  }

  static compare(a, b) {
    if (a.order < b.order) {
      return -1;
    }
    if (a.order > b.order) {
      return 1;
    }
    return 0;
  }


  static stripHtmlTags(html) {
      const tempDiv = document.createElement('div');
      tempDiv.innerHTML = html;
      
      return tempDiv.textContent || tempDiv.innerText || '';
  }

  // Function to calculate total character count
  static calculateTotalCharacterCount(fromName, subjectLine, messageBody, unsubscribeText) {
    let concatText = (fromName ? fromName : "") +
      (subjectLine ? subjectLine : "") +
      (messageBody ? messageBody : "") +
      (unsubscribeText ? unsubscribeText : "");

    concatText = HelperFunctions.replaceMergeTagsWithExample(concatText);

    concatText = HelperFunctions.stripHtmlTags(concatText);

    // Base count for existing string lengths
    const baseCount = concatText.length;

    // Add 2 characters for ': ' after fromName
    const fromNameExtraChars = 2;

    // Add 2 characters for ': ' if subjectLine has a value
    const subjectLineExtraChars = subjectLine ? 1 : 0;

    const messageBodyExtraChars = messageBody?.length ? 1 : 0;

    // Calculate total characters with additional colon and spaces
    const totalCharacters =
      baseCount +
      fromNameExtraChars +
      subjectLineExtraChars +
      messageBodyExtraChars;

    return totalCharacters;
  }

  static replaceMergeTagsWithExample(text) {
    let processedText = text;
    
    // Type 2: ShortLink - {{[ShortLink|"url"|"ShortLink"]}}
    processedText = processedText.replace(
      /\{\{\[ShortLink\|"([^"]*)"\|"ShortLink"\]\}\}/g, 
      (match, url) => {
        const displayValue = Constants.DEFAULT_SHORT_URL;
        return `<span class="merge-tag-pill" style="background-color: #e6f0ff; padding: 2px 6px; border-radius: 12px; font-size: 12px; display: inline; margin: 1px;">${displayValue}</span>`;
        //return displayValue;
      }
    );
    
    // Type 3: Custom - {{[fieldName|"value"|"Custom"]}}
    processedText = processedText.replace(
      /\{\{\[([^|]+)\|"([^"]*)"\|"Custom"\]\}\}/g, 
      (match, fieldName, value) => {
        const displayValue = value && value.trim() !== "" ? value : `${fieldName.trim()} `;
        return `<span class="merge-tag-pill" style="background-color: #e6f0ff; padding: 2px 6px; border-radius: 12px; font-size: 12px; display: inline-block; margin: 1px;">${displayValue}</span>`;
      }
    );
    
    // Type 1: Standard - {{[fieldName|"value"]}}
    const reg = /\{\{\[([^|]+)\|"([^"]*)"\]\}\}/g;
    processedText = processedText.replace(reg, (match, fieldName, defaultValue) => {
      fieldName = fieldName.trim();
      const displayValue = defaultValue && defaultValue.trim() !== "" ? defaultValue : `${fieldName}`;
      return `<span class="merge-tag-pill" style="background-color: #e6f0ff; padding: 2px 6px; border-radius: 12px; font-size: 12px; display: inline-block; margin: 1px;">${displayValue}</span>`;
    });

    return processedText;
  }

  // static replaceMergeTagsWithExample(text) {
  //   var reg = /\{\{\[(?<fieldName>\w+)\|".+"\]\}\}/g;
  //   var matches = text.matchAll(reg);

  //   matches.forEach((match) => {
  //     if (match.groups["fieldName"] === "ShortLink") {
  //       text = text.replace(match[0], "https://a360.site/s/shorturltest");
  //     } 
  //   });
  //   return text;
  // }


  // Function to determine the encoding and segment count
  // static calculateSegmentDetails(fromName, subjectLine, messageBody, unsubscribeText, messageType) {
  //   const GSM_SINGLE_SEGMENT_LIMIT = 160;
  //   const GSM_MULTIPLE_SEGMENT_LIMIT = 153;
  //   const UNICODE_SINGLE_SEGMENT_LIMIT = 70;
  //   const UNICODE_MULTIPLE_SEGMENT_LIMIT = 67;
  //   const MAX_SMS_TOTAL_CHARACTERS = 2048;
  //   const MAX_MMS_TOTAL_CHARACTERS = 1600;
  //   const SMS_TO_Credit_Ratio = 1;
  //   const MMS_TO_Credit_Ratio = 3;

  //   const totalCharacters = HelperFunctions.calculateTotalCharacterCount(fromName, subjectLine, messageBody, unsubscribeText);

  //   const containsUnicode = (str) => {
  //     if (!str) return false; // Handle empty or undefined strings
  //     for (let i = 0; i < str.length; i++) {
  //       if (str.charCodeAt(i) > 127) {
  //         return true;
  //       }
  //     }
  //     return false;
  //   };

  //   // Determine encoding based on the presence of Unicode characters
  //   const isUnicode = [fromName, subjectLine, messageBody].some(containsUnicode);

  //   // Set segment limits based on encoding
  //   const singleSegmentLimit = isUnicode ? UNICODE_SINGLE_SEGMENT_LIMIT : GSM_SINGLE_SEGMENT_LIMIT;
  //   const multipleSegmentLimit = isUnicode ? UNICODE_MULTIPLE_SEGMENT_LIMIT : GSM_MULTIPLE_SEGMENT_LIMIT;

  //   let segmentCount = 1;
  //   if (totalCharacters > singleSegmentLimit) {
  //     segmentCount = messageType === "MMS" ? 1 : Math.ceil(totalCharacters / multipleSegmentLimit);
  //   }

  //   // Set messageType based on encoding
  //   //const messageType = containsImage ? "MMS" : "SMS";

  //   // Determine total character limit based on message type
  //   const maxTotalCharacters = messageType === "MMS" ? MAX_MMS_TOTAL_CHARACTERS : MAX_SMS_TOTAL_CHARACTERS;

  //   const creditCount = messageType === "MMS" ? segmentCount * MMS_TO_Credit_Ratio : segmentCount * SMS_TO_Credit_Ratio;
 
  //   return {
  //     isUnicode,
  //     segmentCount,
  //     //messageType,
  //     maxTotalCharacters,
  //     singleSegmentLimit,
  //     multipleSegmentLimit,
  //     creditCount
  //   };
  // }

  static calculateSegmentDetails(
    fromName,
    subjectLine,
    messageBody,
    unsubscribeText,
    messageType,
    smartEncoding
  ) {
    const GSM_SINGLE_SEGMENT_LIMIT   = 160;
    const GSM_MULTIPLE_SEGMENT_LIMIT = 153;
    const UNICODE_SINGLE_SEGMENT_LIMIT = 70;
    const UNICODE_MULTIPLE_SEGMENT_LIMIT = 67;
    const MAX_SMS_TOTAL_CHARACTERS = 2048;
    const MAX_MMS_TOTAL_CHARACTERS = 1600;
    const SMS_TO_Credit_Ratio = 1;
    const MMS_TO_Credit_Ratio = 3;

    // 1) pre‑map if GSM‑mode (smartEncoding)
    const fn = smartEncoding
      ? HelperFunctions.replaceSmartEncodingChars(fromName   || "")
      : (fromName   || "");
    const sb = smartEncoding
      ? HelperFunctions.replaceSmartEncodingChars(subjectLine|| "")
      : (subjectLine|| "");
    const mb = smartEncoding
      ? HelperFunctions.replaceSmartEncodingChars(messageBody|| "")
      : (messageBody|| "");
    const un = smartEncoding
      ? HelperFunctions.replaceSmartEncodingChars(unsubscribeText|| "")
      : (unsubscribeText|| "");

    // 2) count characters on the result
    const totalCharacters = HelperFunctions.calculateTotalCharacterCount(fn, sb, mb, un);

    // 3) “real” Unicode only if any code‑point >127 remains
    const rendered = fn + sb + mb;
    const containsUnicode = Array.from(rendered).some(ch => ch.charCodeAt(0) > 127);

    // 4) choose limits by detection
    const singleSegmentLimit = containsUnicode
      ? UNICODE_SINGLE_SEGMENT_LIMIT
      : GSM_SINGLE_SEGMENT_LIMIT;
    const multipleSegmentLimit = containsUnicode
      ? UNICODE_MULTIPLE_SEGMENT_LIMIT
      : GSM_MULTIPLE_SEGMENT_LIMIT;

    // 5) segment / credit math
    let segmentCount = 1;
    if (totalCharacters > singleSegmentLimit) {
      segmentCount = messageType === "MMS"
        ? 1
        : Math.ceil(totalCharacters / multipleSegmentLimit);
    }
    const maxTotalCharacters = messageType === "MMS"
      ? MAX_MMS_TOTAL_CHARACTERS
      : MAX_SMS_TOTAL_CHARACTERS;
    const creditCount = messageType === "MMS"
      ? segmentCount * MMS_TO_Credit_Ratio
      : segmentCount * SMS_TO_Credit_Ratio;

    return {
      isUnicode: containsUnicode,
      segmentCount,
      maxTotalCharacters,
      singleSegmentLimit,
      multipleSegmentLimit,
      creditCount
    };
  }


  // Copy All to Clipboard
  static copyTableDataToClipboard(jsonData) {
    var runOldWay = false;
    let csvContent = "";

    try {
      // Exclude the "id" column
      const headers = Object.keys(jsonData[0]).filter(header => header !== 'id');

      // Create a CSV string
      csvContent = `${headers.join(",")}\n${jsonData
        .map((row) => headers.map((header) => row[header]).join(","))
        .join("\n")}`;

      // using clipboard api
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(csvContent)
          .then(() => {
            console.log("Copied to clipboard successfully!");
          })
          .catch(err => {
            runOldWay = true;
          });
      }
      else {
        runOldWay = true;
      }
    }
    catch (err) {
      console.log('error copying to clipboard: ', err);
    }

    if (runOldWay) {
      // Create a temporary textarea element
      const textarea = document.createElement("textarea");
      textarea.textContent = csvContent;

      // Append the textarea to the document
      document.body.appendChild(textarea);

      // Select the text in the textarea
      textarea.select();
      textarea.setSelectionRange(0, 99999);

      // Copy the selected text to the clipboard
      document.execCommand("copy");

      // Remove the temporary textarea
      document.body.removeChild(textarea);
    }
  }

  static isColorDark(hex) {
    if(hex == '#fff' || hex == '#ffffff') { 
      console.log('hex: ', hex);
      return false; 
    }
    if(hex == '#000' || hex == '#000000') { 
      console.log('hex: ', hex);      
      return true;
    }

    // 1) normalize: strip “#”, expand shorthand
    let c = hex.replace(/^#/, '');
    if (c.length === 3) {
      c = c.split('').map(ch => ch + ch).join('');
    }
    if (c.length !== 6) {
      console.warn(`isColorDark: invalid hex "${hex}"`);
      return false;  // assume light
    }

    // 2) parse r, g, b
    const bigint = parseInt(c, 16);
    const r = (bigint >> 16) & 0xff;
    const g = (bigint >>  8) & 0xff;
    const b = bigint & 0xff;

    // 3) compute YIQ — perceptual brightness
    const yiq = (r * 299 + g * 587 + b * 114) / 1000;

    // 4) dark if below threshold
    return yiq < 128;
  }

//  static removeNonAsciiUsingCodePoints(text) {
//   if (!text) return text;

//   let out = "";
//   for (let i = 0; i < text.length; ) {
//     const cp = text.codePointAt(i);
//     const ch = String.fromCodePoint(cp);
//     if (cp <= 0x7f) out += ch;
//     i += cp > 0xffff ? 2 : 1;
//   }
//   return out;
// }
// static removeNonAsciiUsingCodePoints(text) {
//   if (!text) return text;
 
//   const chars = [...text];
//   let left = 0;
//   let right = chars.length - 1;
 
//   while (left <= right) {
//     const cp = chars[left].codePointAt(0);
//     if (cp <= 0x7f) break;
//     left++;
//   }
 
//   while (right >= left) {
//     const cp = chars[right].codePointAt(0);
//     if (cp <= 0x7f) break;
//     right--;
//   }
 
//   return chars.slice(left, right + 1).join('');
// }

static removeNonAsciiUsingCodePoints(text) {
  if (!text) return text;

  const chars = [...text];
  let left = 0;
  let right = chars.length - 1;

  // Move left pointer forward until we hit ASCII
  while (left <= right) {
    const cp = chars[left].codePointAt(0);
    if (cp <= 0x7f) break; 
    left++;
  }

  // Move right pointer backward until we hit ASCII
  while (right >= left) {
    const cp = chars[right].codePointAt(0);
    if (cp <= 0x7f) break; 
    right--;
  }

  return chars.slice(left, right + 1).join('');
}

static markOpen = (nodes, targetId) =>
    nodes.map((node) => {
      const children = node.children ? this.markOpen(node.children, targetId) : [];
      const open = node.id === targetId || children.some((c) => c.open);
      return { ...node, open, children };
    });

static nest = (items, parentId = null, link = "parentId") =>
    items
      .filter((item) => item[link] === parentId)
      .map((item) => ({
        ...item,
        open: false,
        children: HelperFunctions.nest(items, item.id, link),
      }));

}
export default HelperFunctions;
